import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="bg-gray-900 py-12 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold mb-4 text-white">Contact Us</h1>
          <p className="text-xl text-gray-300">
            We'd love to hear from you
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-gray-800 rounded-lg shadow-lg p-8 border border-gray-700"
          >
            <h2 className="text-3xl font-semibold mb-6 text-cyan-100">Get in Touch</h2>
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-300">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="mt-1 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-brand-500 focus:ring-brand-500"               />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-300">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="mt-1 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-brand-500 focus:ring-brand-500"               />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-300">
                  Message
                </label>
                <textarea
                  id="message"
                  rows="4"
                  className="mt-1 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-brand-500 focus:ring-brand-500"               ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-brand-500 text-white py-2 px-4 rounded-md hover:bg-brand-600 transition-colors"
              >
                Send Message
              </button>
            </form>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-8"
          >
            <div>
              <h2 className="text-3xl font-semibold mb-6 text-cyan-100">Contact Information</h2>
              <div className="space-y-4">
                <div className="flex items-center">
                  <FaPhone className="text-brand-500 mr-4" />
                  <span className="text-gray-100">(438) 522-8303</span>
                </div>
                <div className="flex items-center">
                  <FaEnvelope className="text-brand-500 mr-4" />
                  <span className="text-gray-100">healthykitchen@malix.com</span>
                </div>
                <div className="flex items-center">
                  <FaMapMarkerAlt className="text-brand-500 mr-4" />
                  <span className="text-gray-100">1225 Rue Saint-Louis, Lachine, QC</span>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-semibold mb-6 text-cyan-100">Hours of Operation</h2>
              <div className="space-y-2">
                <div className="flex justify-between text-gray-100">
                  <span>Monday - Friday</span>
                  <span>11:00 AM - 9:00 PM</span>
                </div>
                <div className="flex justify-between text-gray-100">
                  <span>Saturday</span>
                  <span>12:00 PM - 10:00 PM</span>
                </div>
                <div className="flex justify-between text-gray-100">
                  <span>Sunday</span>
                  <span>12:00 PM - 8:00 PM</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;